




































































import Vue from 'vue'
import Component from 'vue-class-component'
import RespondecoPortfolioItem from '@/shared/components/respondeco-portfolio-item.vue'
import { Injector } from '@/config/dependency-injection'
import { OrganisationsModule } from '@/business/organisation/store/organisations-module'
import { toPortfolioItem } from '@/shared/utils/portfolio'
import { distanceInWords } from '@/config/i18n'
import { LoaderHelper } from '@/shared/services/loader-helper'
import { FETCH_ORGANISATION_STATISTICS } from '@/business/organisation/store/types'
import { activeUserIsOwner } from '@/shared/utils/user'
import { VueRouter } from 'vue-router/types/router'
import { RouterToken } from '@/config/injection-tokens'
import RespondecoLoadingIndicator from '@/shared/components/respondeco-loading-indicator.vue'

@Component({
  components: { RespondecoLoadingIndicator, RespondecoPortfolioItem },
})
export default class OrganisationStatistics extends Vue {
  public distanceInWords = distanceInWords

  private loaderHelper = Injector.get(LoaderHelper)
  private organisationsModule = Injector.get(OrganisationsModule)
  private router = Injector.get<VueRouter>(RouterToken)

  get isLoading() {
    return this.loaderHelper.isLoading(FETCH_ORGANISATION_STATISTICS)
  }

  get viewModel() {
    return {
      ...this.organisationsModule.organisationStatisticsViewModel,
      visits: this.organisationsModule.organisationStatisticsViewModel.visits.map(entry => {
        return {
          ...entry,
          organisation: toPortfolioItem('organisations', 'organisation')(entry.organisation),
        }
      }),
    }
  }

  // Currently disabled as emptying the state will result in an error if the user is not allowed to
  // perform the navigation.
  //
  // public beforeRouteLeave(to: string, from: string, next: () => {}) {
  //   this.organisationsModule[CLEAR_ORGANISATION_STATISTICS]()
  //
  //   next()
  // }

  public mounted() {
    const organisationId = this.organisationsModule.organisationViewModel.organisation.id

    if (activeUserIsOwner(organisationId)) {
      this.organisationsModule.fetchOrganisationStatistics({
        organisationId,
      })
    } else {
      this.router.push({
        name: 'organisation-offers',
        params: {
          organisationId: String(organisationId),
        },
      })
    }
  }
}
